const gtmForgotPasswordStart = () => {
    const path = window.location.pathname
    dataLayer.push({
        event: 'forgot_password',
        step: 'start_button',
        source_page: path,
        _clear: true,
    })
}

export default gtmForgotPasswordStart
